<div class="header-icon"><i *ngIf="icon" class="icon">{{icon}}</i></div>
<div class="header-name">
    <h2 *ngIf="name">{{name | translate}}
        <app-unredo-buttons class="header-undo-redo"></app-unredo-buttons>
    </h2>
</div>
